import { Injectable } from '@angular/core';
import localesData from '../../assets/locales.json';

@Injectable({
  providedIn: 'root',
})
export class LocaleService {
  public readonly defaultLocale: string = 'en';
  public currentLocale: string;

  public get locales(): string[] {
    return localesData.locales;
  }

  public get availableBrowserLanguages(): Readonly<string[]> {
    const lang = window.navigator.language;
    if (!lang) {
      return [];
    }

    const languages = window.navigator.languages;
    if (!languages) {
      return [lang];
    }

    return [lang].concat(languages.filter((name: string) => name !== lang));
  }

  /**
   * Sets up the user's locale based on browser settings.
   * @returns The locale code to use (e.g., 'en', 'fr', 'de')
   */
  public setUpLocale(): string {
    this.currentLocale = this.getApplicableLocale();
    return this.currentLocale;
  }

  public getApplicableLocale(): string {
    for (const lang of this.availableBrowserLanguages) {
      const locale = this.getLocale(lang);

      if (locale) {
        return locale;
      }
    }

    return this.defaultLocale;
  }

  public getLocale(lang: string): string {
    const locale = this.locales.find(
      (supportedLocale) =>
        supportedLocale.toLocaleLowerCase() === lang.toLocaleLowerCase()
    );
    if (locale) {
      return locale;
    }

    const localeParts = lang.split('-');
    if (localeParts.length > 1) {
      return this.getLocale(localeParts.slice(0, -1).join('-'));
    } else {
      return null;
    }
  }
}
